<div class="col px-lg-5 px-2">
	<!-- <app-nav-gestion-donnees class="row my-5"></app-nav-gestion-donnees> -->

	<div *ngIf="beneficiaire" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ beneficiaire.firstName + ' ' + beneficiaire.lastName }}</span
					>
				</div>

				<div class="">
					<a
						*ngIf="isDeletable"
						(click)="openModal(deleteBeneficiaire)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<div *ngIf="isFormReadOnly">
				<div class="row my-2">
					<div class="col-6">
						<label for="inputAddresse" class="form-label fw-bold"
							>Prénom</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.firstName
						}}</span>
					</div>
					<div class="col-6">
						<label for="inputAddresse" class="form-label fw-bold"
							>Nom</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.lastName
						}}</span>
					</div>
				</div>
				<div class="row my-2">
					<div class="col-7">
						<label for="inputAddresse" class="form-label fw-bold"
							>Adresse</label
						>
						<span class="form-control-plaintext">{{
							beneficiaire?.address?.label
						}}</span>
					</div>
				</div>
			</div>
			<app-beneficiaire-form
				*ngIf="!isFormReadOnly"
				[beneficiaire]="beneficiaire"
				[isAddForm]="false"
				[form]="form"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			>
			</app-beneficiaire-form>
		</div>
		<div class="row my-4">
			<div class="d-flex justify-content-end">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm()"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="!form.valid || isValidateButtonClicked.value"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>

	<div class="row my-5">
		<span class="theme-main-color fw-bold fs-5"
			>Prestations</span
		>
	</div>
	<div class="my-2">
		<div
			*ngFor="
				let prestation of listPrestation
					| paginate : { itemsPerPage: 5, currentPage: currentPage }
			"
			class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
		>
			<div class="col-lg-1 col-10">
				<span class="align-middle limitLineSpanDetails">
					{{ prestation?.numeroCommande }}
				</span>
			</div>
			<div class="col-lg-1 col-10">
				<span class="align-middle limitLineSpanDetails">
					{{ PrestationStatutStringEnum[prestation.statut] }}
				</span>
			</div>
			<div class="col-lg-2 col-10">
				<span class="align-middle limitLineSpanDetails">{{
					PrestationTypeStringEnum[prestation.typePrestation]
				}}</span>
			</div>
			<div class="col-lg-1 col">
				<span class="align-middle limitLineSpanDetails">Date de démarrage: 
					{{ prestation?.dateDebut | date: 'dd/MM/yyyy' }}
				</span>
			</div>
			<div class="col-lg-1 col">
				<span class="align-middle limitLineSpanDetails">Date limite: 
					{{ prestation?.dateLimite | date: 'dd/MM/yyyy' }}
				</span>
			</div>
			<div class="col-lg-2 col-10">
				<span class="align-middle limitLineSpanDetails">Durée prévisionnelle:
					
						{{ prestation?.dureePrevisionnelle}}
					</span
				>
			</div>
			<div class="col-lg-1 col-10">
				<span class="align-middle limitLineSpanDetails">Heures consommées: 
					
					{{ calculateConsumedHours(prestation?.id)}}
					</span
				>
			</div>
			<div class="col-lg-2 col-10">
				<span class="align-middle limitLineSpanDetails"
					>Intervenant: 
					{{ prestation.intervenant?.firstName +
						' ' +
						prestation.intervenant?.lastName }}</span
				>
			</div>
			<div class="col-1 ms-lg-auto hand-cursor">
				<i
					class="fs-4 bi bi-caret-right-fill mb-1"
					aria-hidden="true"
					[routerLink]="['/prestation/appuis-specifiques', prestation?.id]"
					role="button"
				></i>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			></pagination-controls>
		</div>
	</div>

	<!-- <div *ngIf="beneficiaire" class="my-4">
		<div class="row my-5">
			<span class="theme-main-color fw-bold fs-5"
				>{{ labelInterventionPluralizedCapitalized }} programmées</span
			>
		</div>
		<div class="my-2">
			<div
				*ngFor="
					let missionRqEmp of pairMissionRqEmployee
						| sortByMissionDate : sortOrder
						| paginate : { itemsPerPage: 5, currentPage: currentPage }
						| orderBy : 'missionRequest.date' : sortOrder
				"
				class="row pt-4 pb-3 ps-lg-3 rounded rounded-3 bg-light my-2"
				(click)="openModalDetailFormation(missionRqEmp.missionRequest)"
			>
				<div class="col-lg-2 col-10">
					<span class="align-middle">
						{{ missionRqEmp.employeeName }}
					</span>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle">{{
						missionRqEmp.missionRequest.missionType?.type
					}}</span>
				</div>
				<div class="col-lg col" *ngIf="true">
					<span class="align-middle">{{
						missionRqEmp.missionRequest.careSpecialty?.name
					}}</span>
				</div>
				<div class="col-lg-3 col-10" *ngIf="true">
					<span class="align-middle">
						{{
							getMissionPlaceNameAndAddress(missionRqEmp.missionRequest)
						}}</span
					>
				</div>
				<div class="col-lg-2 col-10">
					<span class="align-middle"
						>{{ missionRqEmp.missionRequest.date | date : 'dd/MM/YYYY' }},
						{{ missionRqEmp.missionRequest.readyTime | minutesToTime }} -
						{{ missionRqEmp.missionRequest.dueTime | minutesToTime }}</span
					>
				</div>
				<div class="col-1 ms-lg-auto hand-cursor">
					<i
						class="fs-4 bi bi-caret-right-fill mb-1 align-middle"
						aria-hidden="true"
					></i>
				</div>
			</div>

			<div class="row my-4">
				<pagination-controls
					class="d-flex justify-content-center"
					(pageChange)="currentPage = $event"
					previousLabel="Précédent"
					nextLabel="Suivant"
				></pagination-controls>
			</div>
		</div>
	</div> -->

	<ng-template #deleteBeneficiaire>
		<div class="modal-header text-center">
			<h4>Suppression {{ labelBeneficiaireCapitalized }}</h4>
			<button
				type="button"
				class="btn-close pull-right"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="confirmDeleteModalRef.hide()"
			></button>
		</div>
		<div class="modal-body">
			Êtes-vous sûr de vouloir effectuer la suppression ?
		</div>
		<div class="modal-footer">
			<a
				(click)="confirmDeleteModalRef.hide()"
				class="btn theme-main-color-button"
				>Retour</a
			>
			<a class="btn theme-red-button ms-3" (click)="delete(beneficiaire)"
				>Supprimer</a
			>
		</div>
	</ng-template>
</div>
